import { Logo } from "@/components/brand/Logo";
import { ChatDisclosure } from "@/components/chat/ChatDisclosure";
import { Button } from "@/components/ui/button";
import { SUPPORTED_LANGUAGES } from "@/lib/language";

interface LanguageGateProps {
  propertyName?: string;
  onSelect: (code: string) => void;
}

/** First-screen language chooser shown before the chat when no language is set. */
export function LanguageGate({ propertyName, onSelect }: LanguageGateProps) {
  return (
    <div className="bg-atmosphere grain flex h-dvh flex-col items-center justify-center gap-8 px-6">
      <div className="relative z-10 flex flex-col items-center gap-3 text-center">
        <Logo size={48} />
        {propertyName ? (
          <p className="font-display text-xl tracking-tight text-foreground">{propertyName}</p>
        ) : null}
        <p className="text-sm text-muted-foreground">Select your language · 언어를 선택하세요</p>
      </div>
      <div className="relative z-10 grid w-full max-w-xs grid-cols-2 gap-3">
        {SUPPORTED_LANGUAGES.map((l) => (
          <Button
            key={l.code}
            variant="outline"
            className="h-14 rounded-xl text-base"
            onClick={() => onSelect(l.code)}
          >
            {l.label}
          </Button>
        ))}
      </div>
      <div className="relative z-10 w-full max-w-xs">
        <ChatDisclosure />
      </div>
    </div>
  );
}
